import { z } from "zod";

export const emptyResponseSchema = z.object({});
export const createSyncSessionResponseSchema = z.object({ syncSessionId: z.string() });
export const getSessionInfoResponseSchema = z.object({
  syncSessionId: z.string(),
  almConnectionType: z.string(),
  almConnectionId: z.string(),
});
export const getStatusResponseSchema = z.object({
  status: z.enum(["stopped", "starting", "running", "error", "synced", "syncing"]),
});
export const getLinkTypeResponseSchema = z.object({ linkType: z.record(z.any()).optional() });
export const getLinkTypesResponseSchema = z.object({
  linkTypes: z.array(z.record(z.any())).optional(),
});
export const getALMIssuesResponseSchema = z.object({
  results: z.array(
    z.object({
      issueId: z.string(),
      issueUrl: z.string(),
      summary: z.string(),
      storyPoints: z.union([z.number(), z.null()]).optional(),
      assignee: z
        .union([
          z.object({
            pipId: z.union([z.string(), z.null()]).optional(),
            almId: z.union([z.string(), z.null()]).optional(),
          }),
          z.null(),
        ])
        .optional(),
      issueType: z.string(),
      almTypeId: z.string(),
      sourceId: z.number().int(),
    }),
  ),
  total: z.number().int(),
  limit: z
    .number()
    .int()
    .describe(
      "Maximum number of issues that can be returned. Use to detect if results were truncated.",
    ),
  query: z
    .object({
      sections: z.array(
        z.object({
          name: z
            .string()
            .describe("Section identifier (project, issuetype, team_fields, sprint, assignee)"),
          value: z.string().describe("Query string for this section (format depends on ALM tool)"),
          isDefault: z
            .boolean()
            .describe(
              "True if from board config (default), False if user-influenced (from filters)",
            ),
        }),
      ),
      separator: z.string().describe("Separator used between sections in the full query string"),
    })
    .describe(
      "Optional query metadata. Contains structured sections of the query (format depends on ALM tool).",
    )
    .optional(),
});
